export default __webpack_public_path__ + "static/media/Charlie__Full Logo_White.2242b196.png";